import React, { Component, Fragment } from 'react'

export default class Home extends Component {
    render() {
        return (
            <Fragment>
                <section id="content">
                    <div className="page full-pagewidth-layout">
                        <p>This right here is the Home</p>
                    </div>
                </section>
            </Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Components/Home/Home.js